module.exports = __webpack_public_path__ + "img/GCC_About-ProposedAims.82dbc476.jpg";